import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../../api/client';
export default function SeoStep({ onAdvance, onChanged }) {
    const [report, setReport] = useState(null);
    const [sitemap, setSitemap] = useState('');
    const [busy, setBusy] = useState('load');
    const [error, setError] = useState(null);
    const [fixedNote, setFixedNote] = useState(null);
    async function refresh() {
        setBusy('load');
        setError(null);
        try {
            const r = await api.wizardSeoAudit();
            setReport(r.report);
            setSitemap(r.sitemap);
        }
        catch (e) {
            setError(e?.message ?? 'Failed to audit');
        }
        finally {
            setBusy(null);
            onChanged();
        }
    }
    useEffect(() => { refresh(); }, []);
    async function apply(fixMeta) {
        setBusy('apply');
        setError(null);
        try {
            const r = await api.wizardSeoApply(fixMeta);
            setFixedNote(`Wrote sitemap.xml + robots.txt. ${r.fixed} meta description${r.fixed === 1 ? '' : 's'} rewritten.${r.errors.length ? ' Errors: ' + r.errors.length : ''}`);
            await refresh();
        }
        catch (e) {
            setError(e?.message ?? 'Apply failed');
        }
        finally {
            setBusy(null);
        }
    }
    const cleanCount = (report ?? []).filter((p) => p.issues.length === 0).length;
    const totalIssues = (report ?? []).reduce((n, p) => n + p.issues.length, 0);
    return (_jsxs("div", { className: "step-content", children: [_jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Audit" }), !report && _jsx("div", { className: "muted", children: "Running\u2026" }), report && (_jsxs(_Fragment, { children: [_jsxs("p", { children: [_jsx("strong", { children: cleanCount }), " / ", report.length, " pages clean.", ' ', _jsx("strong", { children: totalIssues }), " total issue", totalIssues === 1 ? '' : 's', "."] }), _jsxs("table", { className: "data-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Page" }), _jsx("th", { children: "Meta length" }), _jsx("th", { children: "Alt missing" }), _jsx("th", { children: "JSON-LD" }), _jsx("th", { children: "Issues" })] }) }), _jsx("tbody", { children: report.map((p) => (_jsxs("tr", { className: p.issues.length === 0 ? '' : 'has-issues', children: [_jsxs("td", { children: [_jsxs("code", { children: ["/", p.slug === 'home' ? '' : p.slug] }), " ", _jsx("span", { className: "muted small", children: p.title })] }), _jsx("td", { className: metaClass(p.meta_length), children: p.meta_length || '—' }), _jsx("td", { className: p.alt_missing > 0 ? 'warn' : '', children: p.alt_missing }), _jsx("td", { children: p.has_schema ? '✓' : '—' }), _jsx("td", { className: "muted small", children: p.issues.length === 0 ? 'all good' : p.issues.join('; ') })] }, p.slug))) })] })] })), _jsxs("div", { className: "step-foot", children: [_jsx("button", { className: "ghost", onClick: refresh, disabled: busy !== null, children: "Re-run audit" }), _jsx("button", { className: "ghost", onClick: () => apply(false), disabled: busy !== null, children: "Write sitemap.xml + robots.txt" }), _jsx("button", { onClick: () => apply(true), disabled: busy !== null, children: busy === 'apply' ? 'Applying…' : 'AI-rewrite weak meta + write sitemap' })] }), fixedNote && _jsx("div", { className: "ok small", children: fixedNote })] }), sitemap && (_jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Generated sitemap.xml (preview)" }), _jsx("pre", { className: "codeblock", children: sitemap })] })), error && _jsx("div", { className: "err small pad-y", children: error }), _jsx("div", { className: "step-foot", children: _jsx("button", { onClick: onAdvance, children: "Continue \u2192" }) })] }));
}
function metaClass(len) {
    if (len === 0)
        return 'warn';
    if (len < 80)
        return 'warn';
    if (len > 170)
        return 'warn';
    return '';
}
